<template>
  <div style="width:100%">
    <van-pull-refresh
      class="pull-refresh"
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <slot />
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  props: {
    refreshCallback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    // 刷新
    async onRefresh() {
      this.isLoading = true;
      this.refreshCallback && (await this.refreshCallback());
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.pull-refresh {
  width: 100%;
  height: 100%;
}
</style>
